module.exports = __webpack_public_path__ + "static/media/49.83880a84.png";